import { normalizeObject, dataLayerPush, getEhashCookie } from "./utils";
/**
 * Normalizes object data and pushes it to the data layer
 */
var dataToDataLayer = function (data) {
    var normalizedData = normalizeObject(data);
    dataLayerPush(normalizedData);
};
var extractChildData = function (sponsoredChildData) {
    return {
        child_id: (sponsoredChildData === null || sponsoredChildData === void 0 ? void 0 : sponsoredChildData.identifier) || '',
        child_community_name: (sponsoredChildData === null || sponsoredChildData === void 0 ? void 0 : sponsoredChildData.projectName) || '',
        child_country_name: (sponsoredChildData === null || sponsoredChildData === void 0 ? void 0 : sponsoredChildData.countryCode) || ''
    };
};
export function handleSAKMessageComposeScreenView(e) {
    var _a = e.detail || {}, topic = _a.topic, sponsoredChildData = _a.sponsoredChildData;
    var _b = extractChildData(sponsoredChildData), child_id = _b.child_id, child_community_name = _b.child_community_name, child_country_name = _b.child_country_name;
    var event_label = topic;
    var ehash = getEhashCookie();
    dataToDataLayer({
        event: "msc_message",
        event_action: "msc:message_compose_view",
        event_category: "msc_message",
        event_label: event_label,
        ehash: ehash,
        msc_child_id: child_id,
        msc_community_name: child_community_name,
        msc_country_name: child_country_name,
        non_interaction: true
    });
}
export function handleSAKMessageCompositionStart(e) {
    var _a = e.detail || {}, topic = _a.topic, sponsoredChildData = _a.sponsoredChildData;
    var _b = extractChildData(sponsoredChildData), child_id = _b.child_id, child_community_name = _b.child_community_name, child_country_name = _b.child_country_name;
    var event_label = topic;
    var ehash = getEhashCookie();
    dataToDataLayer({
        event: "msc_message",
        event_action: "msc:message_compose_start",
        event_category: "msc_message",
        event_label: event_label,
        ehash: ehash,
        msc_child_id: child_id,
        msc_community_name: child_community_name,
        msc_country_name: child_country_name
    });
}
export function handleSAKMessageSendSuccess(e) {
    var _a = e.detail || {}, post_purchase_task_completion_time = _a.post_purchase_task_completion_time, topics = _a.topics, sponsoredChildData = _a.sponsoredChildData;
    var _b = extractChildData(sponsoredChildData), child_id = _b.child_id, child_community_name = _b.child_community_name, child_country_name = _b.child_country_name;
    var event_label = topics;
    var ehash = getEhashCookie();
    dataToDataLayer({
        event: "msc_message",
        event_action: "msc:message_send_success",
        event_category: "msc_message",
        event_label: event_label,
        ehash: ehash,
        msc_child_id: child_id,
        msc_community_name: child_community_name,
        msc_country_name: child_country_name,
        post_purchase_task_completion_time: post_purchase_task_completion_time,
        ret_sponsored_child_message_send_success: 1,
        retain_interactions: 1,
        message_bible_verse: null,
        message_send_template: event_label,
        message_send_attach_photo: "attached_photo"
    });
}
export function handleSAKMessageError(e) {
    var _a = e.detail || {}, topics = _a.topics, sponsoredChildData = _a.sponsoredChildData, error_message = _a.error_message, error_type = _a.error_type;
    var _b = extractChildData(sponsoredChildData), child_id = _b.child_id, child_community_name = _b.child_community_name, child_country_name = _b.child_country_name;
    var event_label = topics;
    var ehash = getEhashCookie();
    dataToDataLayer({
        event: "msc_message",
        event_action: "msc:message_error",
        event_category: "msc_message",
        event_label: event_label,
        ehash: ehash,
        msc_child_id: child_id,
        msc_community_name: child_community_name,
        msc_country_name: child_country_name,
        error_message: error_message,
        error_type: error_type,
        non_interaction: true
    });
}
export function handleSAKPhotoUploadClick(e) {
    var _a = (e === null || e === void 0 ? void 0 : e.detail) || {}, event_action = _a.event_action, event_category = _a.event_category, event_label = _a.event_label;
    dataToDataLayer({
        event: "photo_upload_click",
        event_action: event_action,
        event_category: event_category,
        event_label: event_label
    });
}
;
export function handleSAKPhotoModError(e) {
    var _a = (e === null || e === void 0 ? void 0 : e.detail) || {}, event_action = _a.event_action, event_category = _a.event_category, event_label = _a.event_label, error_message = _a.error_message, error_type = _a.error_type;
    dataToDataLayer({
        event: "error_view",
        event_action: event_action || "reject",
        event_category: event_category || "chosen_error",
        event_label: event_label,
        error_message: error_message,
        error_type: error_type,
        event_errors: 1,
        non_interaction: true,
        total_errors: 1
    });
}
;
